import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from '@saucelabs/sl-component-overlay';

import Styles from './MobileAppDescription.styles';

const MobileAppDescription = ({ displayName, id, thumbnail }) => (
  <div className={Styles.default}>
    <span>
      {thumbnail}
    </span>
    <OverlayTrigger
      overlay={(
        <Tooltip id={`mobile-app-name-${id}-tooltip`}>
          {displayName}
        </Tooltip>
      )}
      placement="top"
      rootClose
    >
      <span className={Styles['display-name']}>{displayName}</span>
    </OverlayTrigger>
  </div>
);

MobileAppDescription.propTypes = {
  displayName: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  thumbnail: PropTypes.element.isRequired,
};

export default MobileAppDescription;
